import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {CancelDeliveryComponent} from './containers/cancel-delivery/cancel-delivery.component';
import {IonicModule} from '@ionic/angular';
import {SharedModule} from '../../shared/shared.module';
import {CancelDeliveryModalComponent} from './components/cancel-delivery-modal/cancel-delivery-modal.component';

const routes: Routes = [
  { path: '', component: CancelDeliveryComponent }
];

@NgModule({
  declarations: [CancelDeliveryComponent, CancelDeliveryModalComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    IonicModule,
    SharedModule
  ]
})
export class CancelDeliveryModule { }
